import { CheckLabelContainer } from "./styles/HelperTooltip";
import { Tooltip } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";

const HelperTooltip = ({
  label = "",
  tooltipText = "",
  placement = "right",
  tooltipStyle = {},
  tooltipColor = "lightgrey",
}) => (
  <CheckLabelContainer tooltipColor={tooltipColor}>
    {label && <p>{label}</p>}
    <Tooltip
      title={tooltipText}
      arrow
      placement={placement}
      style={tooltipStyle}
    >
      <HelpIcon />
    </Tooltip>
  </CheckLabelContainer>
);

export default HelperTooltip;
